<template>
  <article class="banner">
    <figure class="banner__image">
      <img :src="bannerImage" class="banner__image__source" />
      <figcaption class="banner__image__caption">
        <div class="banner__image__options">
          <a @click="copyAd" class="banner__image__copy"></a>
          <a @click="deleteAd" class="banner__image__trash"></a>
        </div>
        <router-link :to="link" class="banner__image__view"><span>Edit</span></router-link>
        <a v-if="!isAppStandalone()" v-on:click="useNow" href="#" class="banner__image__use"><span>Use Now</span></a>
        <a v-on:click.prevent="showModal" href="#" class="banner__image__export"><span>Get Code</span></a>
      </figcaption>
    </figure>

    <header class="banner__header">
      <h1 class="banner__title">{{ title }}</h1>
    </header>
    <section class="banner__section">
      <p v-if="size" class="banner__currentsize">{{ getCurrentSizes }}</p>
    </section>
  </article>
</template>

<script>
  import { passback } from '../../lib/integration';
  import {mapState} from 'vuex'

  export default {
    name: 'banner-item',
    props: ['title', 'id', 'formatId', 'size', 'link', 'banner'],
    computed: {
      ...mapState('advertisements', ['ads']),
      bannerImage() {
        if (this.banner.preview && this.banner.preview.url) {
          return this.banner.preview.url;
        } else {
            // 'data:image/svg+xml;base64,'
          return this.previewImage();
        }
      },
      getCurrentSizes () {
        if (this.size.type === 'flexible') {
          return `${this.size.type.substring(0, 1).toUpperCase().concat(this.size.type.substring(1))}: ${this.size.width}:${this.size.height}`;
        } else {
          return `${this.size.type.substring(0, 1).toUpperCase().concat(this.size.type.substring(1))}: ${this.size.width}x${this.size.height}`;
        }
      }
    },
    methods: {
      showModal() {
        let advert = this.ads.filter((ad)=>{
          return this.id == ad.id;
        })[0]
        this.$parent.showModal(advert);
      },
      useNow() {
        console.log('banner', JSON.stringify(this.banner));
        this.banner.inputs = this.banner.json;
        passback(this.banner);
      },
      previewImage () {
        let formats = this.$store.getters['formats/formats'];
        let previewImage;
        let currentFormatId = this.formatId;
        formats.forEach(function (format) {
          if (format.id === currentFormatId) {
            previewImage = format.preview_image;
          }
        });
        return previewImage;
      },
      copyAd () {
        this.$emit('copied', this.id);
      },
      deleteAd () {
        this.$emit('deleted', this.id);
      }
    },
    data(){
      return {
        value: null
      }
    },
    watch: {
      value(newVal){
        this.$emit('input', newVal);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/BannerItem.vue